import DOMPurify from "dompurify";

// Tout lien d'une réponse ou d'une source s'ouvre dans un nouvel onglet
// (22.10.2026) : un clic dans le texte ne doit pas faire quitter l'app, et la
// conversation en cours. Posé une fois sur DOMPurify, que traversent tous les
// rendus HTML (réponses, passages, document entier, citations de la v1). Les
// ancres internes (« #… ») restent dans la page.

let installed = false;

export function installLinkTargets(): void {
  if (installed) return;
  installed = true;
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName !== "A") return;
    const href = node.getAttribute("href") ?? "";
    if (!href || href.startsWith("#")) return;
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  });
}

installLinkTargets();
